import React from "react";
import { useForm } from "react-hook-form";
import { usePutCustomerUpdateStatusMutation } from "@tiny/api";
import { UnsubscribeReasonDialogProps } from "./UnsubscribeReasonDialog";

interface UnsubscribeFormValues {
  statusReason: string;
}

export function useUnsubscribeReasonDialog(
  props: UnsubscribeReasonDialogProps
) {
  const { open, onSuccess, customer } = props;

  const form = useForm<UnsubscribeFormValues>();

  const { mutateAsync: updateCustomerStatusMutateAsync, isLoading: saving } =
    usePutCustomerUpdateStatusMutation();

  const submitForm = React.useCallback(
    async (values: UnsubscribeFormValues) => {
      if (customer?.id) {
        await updateCustomerStatusMutateAsync({
          customerId: customer.id,
          status: "Unsubscribed",
          statusReason: values.statusReason,
        });
        onSuccess();
      }
    },
    [customer?.id, onSuccess, updateCustomerStatusMutateAsync]
  );

  const save = React.useCallback(async () => {
    form.handleSubmit(submitForm)();
  }, [form, submitForm]);

  React.useEffect(() => {
    if (open) {
      form.reset({ statusReason: "" });
    } else {
      form.reset({});
    }
  }, [form, open]);

  return {
    form,
    submitForm,
    save,
    saving,
  };
}
